namespace app.certification {
    "use strict";
    
    angular.module("app.certification", ["app.autenticado"]);
}